<template>
  <div v-for="attribute in availableAttributes" class="not-last:mb-20">
    <h3 class="text-md font-semibold mb-5">{{ attribute.label }}</h3>
    <ul class="flex gap-20">
      <li v-for="value in attribute.values" :key="value.variation?.id">
        <NuxtLink
          v-if="value.variation?.url?.path"
          :to="value.variation.url.path"
          :class="{
            'font-semibold text-green underline underline-offset-4':
              value.variation.id === activeVariationId,
          }"
        >
          {{ value.label }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type {
  CommercePreparedAttributeFragment,
  CommerceProductPageVariationItemFragment,
} from '#graphql-operations'

const props = defineProps<{
  attributes?: CommercePreparedAttributeFragment[]
  activeVariationId?: string
  allVariations: CommerceProductPageVariationItemFragment[]
}>()

const availableAttributes = computed(() => {
  return props.attributes?.filter((v) => !!v.values?.length) || []
})
</script>
